<template>
  <div>
    <b-form class="needs-validation"
            >
      <b-row>
        <b-col xl="4" lg="4" sm="4">
          <p class="mt-3">
            <span class="h3">Plan Name</span>
          </p>
        </b-col>
        <b-col xl="8" lg="8" sm="8">
          <b-form-group
            label-for="input-1"
          >
            <b-form-input
              id="input-1"
              :state="planNameStatus"
              v-model="newBrandDataPlanForm.planName"
              placeholder="{PLAN_CODE_DSL{PLAN_SPEAD} ex. 123ZY_DSL100}}"
            ></b-form-input>
            <b-form-invalid-feedback :state="planNameStatus">
              Please enter a valid plan name.
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col xl="4" lg="4" sm="4">
          <p class="mt-3">
            <span class="h3">Plan Speed</span>
          </p>
        </b-col>
        <b-col xl="8" lg="8" sm="8">
          <b-form-group
            label-for="input-1"
          >
            <b-form-input
              id="input-1"
              :state="planSpeedStatus"
              v-model="newBrandDataPlanForm.planSpeed"
              placeholder="ex. 3M/6M"
            ></b-form-input>
            <b-form-invalid-feedback :state="planSpeedStatus">
              Please enter a valid Plan Speed
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col xl="4" lg="4" sm="4">
          <p class="mt-3">
            <span class="h3">Update Interval</span>
          </p>
        </b-col>
        <b-col xl="8" lg="8" sm="8">
          <b-form-group label-for="input-1">
            <b-form-input
              id="input-1"
              :state="intervalStatus"
              v-model="newBrandDataPlanForm.interval"
              placeholder="value in seconds ex. 60"
            ></b-form-input>
            <b-form-invalid-feedback :state="intervalStatus">
              Please enter a valid update interval
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <hr>

      <div class="mt-3 d-flex justify-content-between">
        <base-button type="white" title="Close"  v-on:click="modalClose()">
          Close
        </base-button>
        <base-button type="primary" title="Search"  v-on:click="newBroadbandPlanSubmit" :loading="submitLoading">
          Submit
        </base-button>
      </div>
    </b-form>

  </div>
</template>

<script>
  import administratorService from "../../common/api-services/administrator-service";
  import handleResponse from "../../common/directive/handlResponse";

  export default {
    name: "New-Broadband-Data-Plan",
    computed: {
      planNameStatus() {
        return this.newBrandDataPlanForm.planName.length > 0
      },
      planSpeedStatus() {
        return this.newBrandDataPlanForm.planSpeed.length > 0
      },
      intervalStatus() {
        return this.newBrandDataPlanForm.interval.length > 0
      }
    },
    data() {
      return {
        newBrandDataPlanForm: {
          planName: '',
          planSpeed: '',
          interval: '60',
        },
        submitLoading: false
      }
    },
    mounted() {

    },
    methods: {

      modalClose() {
        this.$bvModal.hide('new-broadband-data-plan');
      },

      newBroadbandPlanSubmit() {
        if (this.planNameStatus && this.planSpeedStatus && this.intervalStatus) {
          this.submitLoading = true;
          this.newBrandDataPlans();
        }
      },

      newBrandDataPlans() {
        administratorService.addDslDataPlans(this.newBrandDataPlanForm).then(res => {
          this.submitLoading = false;
          let {type, msg} = handleResponse.apiResponse(res);
          this.$toast(msg, {type: type})
          this.modalClose();
          this.$root.$emit('addNewBroadbandDataPlans')
        })
      },
    }
  }
</script>

<style scoped>

</style>
